/* eslint-disable @typescript-eslint/no-explicit-any */
import { PortableText } from "@portabletext/react";
import { usePortableTextComponents } from "@/hooks/use-portable-text-components";

const PortableTextRenderer = ({ value }: { value: any }) => {
  const components = usePortableTextComponents();
  return <PortableText value={value} components={components} />;
};

export default PortableTextRenderer;
